import PersonalOrderTracker from '../PersonalOrdersTracker';
import { loadStripe } from '@stripe/stripe-js/pure'; // TODO Implement later (ref: https://github.com/quipper/aya-issues/issues/80546)
import {
  Stripe,
  StripeElements,
  Appearance,
  StripePaymentElementOptions,
} from '@stripe/stripe-js';

// see app/views/layouts/_stripe_config.html.slim
declare const stripeConfig: any;

$(() => {
  class BaseForm {
    el: JQuery<HTMLElement>;

    constructor(el: JQuery<HTMLElement>) {
      this.el = el;
    }

    validate() {
      return this._validateWithServer();
    }

    submit() {
      return $.post(this.el.attr('action')!, this.serialize());
    }

    // NOTE: We never send a credit card information in all kinds of forms
    serialize(): string {
      const filtered = this.el.serializeArray().filter(
        ({ name, value }) =>
          (name != 'order[coupon_code]' || value != '') && // NOTE: Ad-hoc fix to remove duplicated key-value pair from FormData.
          (name != 'order[tracking_code]' || value != ''), // Don't send tracking_code if it is empty, not to send both coupon code and tracking code for basic plan
      );
      const appended = filtered.concat(this._additionalFormData());
      return $.param(appended);
    }

    _validateWithServer() {
      return $.post(this.el.data('validation-path')!, this.serialize());
    }

    _additionalFormData(): { name: string; value: any }[] {
      return [];
    }
  }

  class CreditCardForm extends BaseForm {
    private confirmSetupIntent: () => Promise<any>;
    private stripeElements: StripeElements;
    private stripePaymentMethodId: string | undefined;
    private stripeIdempotencyKey: string | undefined;
    private coupon_code: string | undefined;

    constructor(
      el: JQuery<HTMLElement>,
      confirmSetupIntent: () => Promise<any>,
      stripeElements: StripeElements,
      coupon_code?: string,
    ) {
      super(el);
      this.confirmSetupIntent = confirmSetupIntent;
      this.stripeElements = stripeElements;
      this.coupon_code = coupon_code;
    }

    validate(): any {
      return this.stripeElements
        .submit()
        .then((result: any) => {
          if (result.error) {
            return new Promise((_, reject) => reject([result.error.message]));
          }
          return;
        })
        .then(this._validateWithServer.bind(this))
        .then(this.confirmSetupIntent.bind(this))
        .then(
          ([stripePaymentMethodId, stripeIdempotencyKey]: [string, string]) => {
            this.setStripeVariables(
              stripePaymentMethodId,
              stripeIdempotencyKey,
            );
          },
        );
    }

    setStripeVariables(
      stripePaymentMethodId: string,
      stripeIdempotencyKey: string,
    ): void {
      this.stripePaymentMethodId = stripePaymentMethodId;
      this.stripeIdempotencyKey = stripeIdempotencyKey;
    }

    _additionalFormData(): { name: string; value: any }[] {
      return [
        {
          name: 'order[stripe_payment_method_id]',
          value: this.stripePaymentMethodId,
        },
        {
          name: 'order[stripe_idempotency_key]',
          value: this.stripeIdempotencyKey,
        },
        {
          name: 'order[coupon_code]',
          value: this.coupon_code || '',
        },
      ];
    }
  }

  class KonbiniForm extends BaseForm {
    private stripeIdempotencyKey: string | undefined;

    constructor(el: JQuery<HTMLElement>, stripeIdempotencyKey: string) {
      super(el);
      this.stripeIdempotencyKey = stripeIdempotencyKey;
    }

    validate() {
      return this._validateWithServer();
    }

    _additionalFormData(): { name: string; value: any }[] {
      return [
        {
          name: 'order[stripe_idempotency_key]',
          value: this.stripeIdempotencyKey,
        },
      ];
    }
  }

  class RegistrationPersonalOrderView {
    private ui: {
      rawForm: JQuery<HTMLElement>;
      spotOuter: JQuery<HTMLElement>;
      wizard: JQuery<HTMLElement>;
      paymentMethodRadio: JQuery<HTMLElement>;
      priceIdRadio: JQuery<HTMLElement>;
      couponInput: JQuery<HTMLElement>;
      applyCouponButton: JQuery<HTMLElement>;
      couponInputForm: JQuery<HTMLElement>;
      appliedCouponInfo: JQuery<HTMLElement>;
      appliedCouponCode: JQuery<HTMLElement>;
      appliedCouponName: JQuery<HTMLElement>;
      couponErrorMessage: JQuery<HTMLElement>;
      trackingCode: JQuery<HTMLElement>;
      alertRow: JQuery<HTMLElement>;
      backButton: JQuery<HTMLElement>;
      freeTermAnnotation: JQuery<HTMLElement>;
      campaignWebcvsAnnotation: JQuery<HTMLElement>;
      stripePaymentElement: JQuery<HTMLElement>;
      selectContainer: JQuery<HTMLElement>;
      select: JQuery<HTMLElement>;
      basicOnlyApply: JQuery<HTMLElement>;
    };
    private pageNames: string[];
    private plan: string | undefined;
    private stripe: Stripe;
    private stripeElements: StripeElements | undefined;
    private setupIntentClientSecret: string | undefined;
    private stripeIdempotencyKey: string | undefined;
    private canMoveToPaymentDetail: boolean;
    private tracker: PersonalOrderTracker | undefined;
    private form: CreditCardForm | BaseForm | undefined;

    constructor(stripe: Stripe) {
      this.ui = {
        rawForm: $(`${$.rails.formSubmitSelector}#new-order-v2`),
        spotOuter: $('.spot-outer'),
        wizard: $('.wizard'),
        paymentMethodRadio: $('input[name="order[payment_method]"]'),
        priceIdRadio: $('input[name="order[price_id]"]'),

        // クーポン入力フォーム
        couponInput: $('.payment-detail-credit-coupon-input'),
        couponInputForm: $('.coupon-input-form'),
        applyCouponButton: $('.apply-coupon-button'),

        // 適用したクーポン情報
        appliedCouponInfo: $('.applied-coupon-info'),
        appliedCouponCode: $('.applied-coupon-info .coupon-code'),
        appliedCouponName: $('.applied-coupon-info .coupon-name'),

        // クーポンが適用できなかった場合のエラーメッセージ
        couponErrorMessage: $('.coupon-error-message'),

        trackingCode: $('input[name="order[tracking_code]"]'),
        alertRow: $('.alert-row'),
        backButton: $('.btn[data-move=back]'),
        freeTermAnnotation: $('.free-term-annotation'),
        campaignWebcvsAnnotation: $('#campaign-webcvs-annotation'),
        stripePaymentElement: $('#stripe-payment-element'),

        // select
        selectContainer: $('.select2-container'),
        select: $('select'),

        // only when using template is `basic_only`
        basicOnlyApply: $('#basic-only-apply'),
      };

      this.pageNames = ['choose_plan', 'payment_detail'];

      this.plan = undefined;

      this.stripe = stripe;
      this.stripeElements = undefined;
      this.setupIntentClientSecret = undefined;
      this.stripeIdempotencyKey = undefined;

      this.canMoveToPaymentDetail = true;

      this.ui.applyCouponButton.on('click', this.onApplyCoupon.bind(this));
    }

    private onApplyCoupon(e: JQuery.Event): void {
      e.preventDefault();

      if (this.ui.applyCouponButton.prop('disabled')) {
        return;
      }

      this.ui.applyCouponButton.prop('disabled', true);

      this.getInvoicesPreview()
        .then((response) => {
          this.renderInvoicesPreview(response);

          // 現在選択されている支払い周期の表示を反映
          const $selectedRadio = this.ui.priceIdRadio.filter(':checked');
          if ($selectedRadio.length) {
            this.toggleInvoicesPreview({ currentTarget: $selectedRadio[0] });
          }
        })
        .catch(() => {
          this.showAlert(['クーポンを適用できませんでした']);
        });
    }

    begin(): void {
      this.initializeHistoryHandlers();
      this.hideAlert();
      this.ui.freeTermAnnotation.hide();
      this.ui.campaignWebcvsAnnotation.hide();

      this.tracker = new PersonalOrderTracker().begin();

      // プラン選択画面 → 支払い情報入力画面へ遷移時のイベント
      $('#choose-plan').on(
        'qs.wizard.moving',
        this.initPaymentDetail.bind(this),
      );
      // 支払い情報入力画面 → プラン選択画面へ遷移時のイベント
      $('#payment-detail').on('qs.wizard.moving', this.hideAlert.bind(this));

      this.ui.wizard.on('qs.wizard.shown', this.toggleSpotByStep.bind(this));
      this.ui.wizard.on('qs.wizard.shown', this.scrollToTop.bind(this));

      this.ui.rawForm.on('submit', this.submit.bind(this));
      this.ui.rawForm.on('keypress', (e) => {
        // Prevent users from submitting a form by hitting Enter
        if (e.keyCode == 13) e.preventDefault();
      });

      this.ui.paymentMethodRadio.on(
        'change',
        this.toggleFreeTermAnnotation.bind(this),
      );
      this.ui.paymentMethodRadio.on(
        'change',
        this.toggleCampaignWebcvsAnnotation.bind(this),
      );
      this.ui.paymentMethodRadio.on('change', (e: Event) =>
        this.colorSelectedCardInSamePage(e, '#choose-plan'),
      );
      this.ui.priceIdRadio.on('change', (e: Event) =>
        this.colorSelectedCardInSamePage(e, '#payment-detail'),
      );
      this.ui.priceIdRadio.on('change', this.toggleInvoicesPreview.bind(this));

      // select2 does not allow us to use custom keypress event so we use keyup event
      // ref. https://github.com/select2/select2/blob/ebf10c93db7d6d7a0d1330119d4c6f32cbd231d7/src/js/select2/core.js#L350
      this.ui.selectContainer.on(
        'click keyup',
        this.toggleRequiredClass.bind(this),
      );
      this.ui.select.on('change', this.toggleHasValue.bind(this));

      this.ui.basicOnlyApply.on('click', this.onPlanDecided.bind(this));
    }

    private initializeHistoryHandlers(): void {
      if (!window.history?.pushState) return;

      history.replaceState(null, '', `new#${this.pageNames[0]}`);

      this.ui.wizard.on('qs.wizard.shown', (_, data) => {
        if (data.currentIndex > data.previousIndex) {
          history.pushState(
            null,
            '',
            `new#${this.pageNames[data.currentIndex]}`,
          );
          window.krt?.('send', 'view');
        }
      });

      $(window).on('popstate', this.popStateHandler.bind(this));
      this.ui.backButton.on('click', this.callHistoryBack.bind(this));
    }

    private popStateHandler(): void {
      ($('.wizard') as any).wizard('back');
      window.krt?.('send', 'view');
    }

    private callHistoryBack(e: JQuery.Event): void {
      // Go back via the popStateHandler instead of the wizard event
      // to ensure the same behavior for the following two cases:
      //   1. the user clicks their browser's back button
      //   2. the user clicks @ui.backButton which we provide on the page
      e.preventDefault();
      history.back(); // It calls popStateHandler
      window.krt?.('send', 'view');
    }

    private toggleSpotByStep(_: JQuery.Event, data: any): void {
      const currentStep =
        data.currentIndex === 0 ? '.choose-plan-step' : '.payment-detail-step';
      this.ui.spotOuter.removeClass('active');
      this.ui.spotOuter.filter(currentStep).addClass('active');
    }

    private scrollToTop(_: JQuery.Event, data: any): void {
      if (data.previousIndex < data.currentIndex) this.scrollTo(0); // Scroll to form top only when step goes on
    }

    private scrollTo(top: number): void {
      $('html,body').stop().animate({ scrollTop: top });
    }

    private getPaymentMethod() {
      const paymentMethod = this.ui.paymentMethodRadio.filter(':checked').val();
      if (typeof paymentMethod !== 'string') {
        throw new Error('Payment method is not a string');
      }

      return paymentMethod;
    }

    private onPlanDecided(e: Event): void {
      if (!(e.currentTarget instanceof HTMLElement)) {
        return;
      }

      this.plan = $(e.currentTarget).data('plan');

      if (this.plan === 'basic') {
        this.togglePaymentDetailByPaymentMethod(
          this.plan,
          this.getPaymentMethod(),
        );
      } else {
        throw new TypeError(`Unexpected plan (${this.plan}) is given.`);
      }
    }

    private toggleFreeTermAnnotation(): void {
      if (this.getPaymentMethod() === 'stripe_card') {
        this.ui.freeTermAnnotation.hide();
      } else {
        this.ui.freeTermAnnotation.show();
      }
    }

    private toggleCampaignWebcvsAnnotation(): void {
      if (this.getPaymentMethod() === 'webcvs') {
        this.ui.campaignWebcvsAnnotation.show();
      } else {
        this.ui.campaignWebcvsAnnotation.hide();
      }
    }

    private togglePaymentDetailByPaymentMethod(
      plan: string,
      paymentMethod: string,
    ): void {
      // Reset parental_consent all of payment type
      $('input[name="order[parental_consent]"]').each((_, el) => {
        $(el).prop('checked', false);
      });

      const $paymentDetail = $(
        `.payment-detail.payment-detail-${paymentMethod}`,
      );
      $paymentDetail.show();
      $(`.payment-detail:not(.payment-detail-${paymentMethod})`).hide();

      let dom;
      if (paymentMethod === 'stripe_card') {
        $paymentDetail.find(`.plan-based.payment-detail-${plan}`).show();
        $paymentDetail.find(`.plan-based:not(.payment-detail-${plan})`).hide();
        dom = $(`.payment-detail-${plan}`).find(this.ui.priceIdRadio);
      } else {
        dom = this.ui.priceIdRadio;
      }

      $paymentDetail.find(dom).first().prop('checked', true).trigger('change');

      // クーポンコードフィールドのリセット
      // お支払い情報画面からブラウザバックでコース選択に戻り、ふたたびお支払い情報に遷移する場合に
      // クーポンコードフィールドをリセット (ふたたび入力可能な状態にする) ための処理
      this.ui.couponInput.val('');
      this.ui.couponInput.prop('disabled', false);
      this.ui.applyCouponButton.prop('disabled', false);

      this.ui.trackingCode.val('');
      this.ui.trackingCode.prop('disabled', true);
      $paymentDetail.find(this.ui.trackingCode).prop('disabled', false);

      this.tracker?.replaceYtmSelector(plan, this.getPaymentMethod());
    }

    private fetchSetupIntentSecret(): JQuery.jqXHR<any> {
      return $.post(this.ui.rawForm.data('setup-intent-path'));
    }

    private fetchStripeIdempotencyKey(): JQuery.jqXHR<any> {
      // getだとセッション切れの場合にリダイレクトの結果ログイン画面が返却されるためpostにしている
      return $.post(this.ui.rawForm.data('idempotency-key-path'));
    }

    private fetchCustomerSessionSecret(): JQuery.jqXHR<any> {
      return $.post(this.ui.rawForm.data('customer-session-path'));
    }

    private mountStripePaymentElement(
      clientSecret: string,
      customerSessionClientSecret: string,
    ): void {
      const appearance: Appearance = { theme: 'stripe' };
      this.stripeElements = this.stripe.elements({
        appearance,
        clientSecret,
        customerSessionClientSecret,
      });
      const paymentElementOptions: StripePaymentElementOptions = {
        layout: 'accordion',
        fields: {
          billingDetails: {
            name: 'auto',
            address: { country: 'never' },
          },
        },
        wallets: {
          //  ref: https://docs.google.com/document/d/1d-PaVz_xxy05F0jUkRM8a_icmbBF_lSw2PsIMiR_yGM/edit#bookmark=id.qq9rx5tb0d1l
          applePay: 'never',
          googlePay: 'never',
        },
      };
      const paymentElement = this.stripeElements.create(
        'payment',
        paymentElementOptions,
      );
      paymentElement.mount('#stripe-payment-element');
    }

    private initPaymentDetail(_: JQuery.Event, data: any): void {
      this.hideAlert();

      if (
        data.nextStep.attr('id') !== 'payment-detail' ||
        !this.canMoveToPaymentDetail
      )
        return;
      this.canMoveToPaymentDetail = false;

      data.cancelling = true; // stop moving
      $.rails.disableFormElements(this.ui.rawForm);

      if (this.getPaymentMethod() === 'stripe_card') {
        this.initPaymentDetailCard();
      } else if (this.getPaymentMethod() === 'stripe_konbini') {
        this.initPaymentDetailKonbini();
      }
    }

    private initPaymentDetailCard(): void {
      this.initStripeElement()
        .then(this.getInvoicesPreview.bind(this))
        .then(this.renderInvoicesPreview.bind(this))
        .done(() => {
          this.togglePaymentDetailByPaymentMethod(
            this.plan!,
            this.getPaymentMethod(),
          );
          (this.ui.wizard as any).wizard('next');
        })
        .fail(this.onFailure.bind(this))
        .always(() => {
          this.canMoveToPaymentDetail = true;
          $.rails.enableFormElements(this.ui.rawForm);
        });
    }

    private initPaymentDetailKonbini(): void {
      this.getInvoicesPreview()
        .then(this.renderInvoicesPreview.bind(this))
        .then(this.fetchStripeIdempotencyKey.bind(this))
        .then((data) => {
          this.stripeIdempotencyKey = data.stripe_idempotency_key;
        })
        .done(() => {
          this.togglePaymentDetailByPaymentMethod(
            this.plan!,
            this.getPaymentMethod(),
          );
          (this.ui.wizard as any).wizard('next');
        })
        .fail(this.onFailure.bind(this))
        .always(() => {
          this.canMoveToPaymentDetail = true;
          $.rails.enableFormElements(this.ui.rawForm);
        });
    }

    private initStripeElement() {
      return this.fetchSetupIntentSecret()
        .then((data) => {
          this.setupIntentClientSecret = data.client_secret;
        })
        .then(this.fetchStripeIdempotencyKey.bind(this))
        .then((data) => {
          this.stripeIdempotencyKey = data.stripe_idempotency_key;
        })
        .then(this.fetchCustomerSessionSecret.bind(this))
        .then((data) => {
          this.mountStripePaymentElement(
            this.setupIntentClientSecret!,
            data.client_secret,
          );
        });
    }

    private confirmSetupIntent() {
      // ref: https://docs.stripe.com/payments/save-and-reuse?platform=web&ui=elements#submit-payment-details
      return this.stripe
        .confirmSetup({
          clientSecret: this.setupIntentClientSecret!,
          elements: this.stripeElements!,
          redirect: 'if_required',
          confirmParams: {
            payment_method_data: {
              billing_details: {
                address: {
                  country: 'JP',
                },
              },
              allow_redisplay: 'always',
            },
          },
        })
        .then((result) => {
          if (result.error) {
            return new Promise((_, reject) => reject([result.error.message]));
          } else {
            return [
              result.setupIntent.payment_method,
              this.stripeIdempotencyKey!,
            ];
          }
        });
    }

    private colorSelectedCardInSamePage(e: Event, pageId: string): void {
      if (!(e.currentTarget instanceof HTMLElement)) {
        return;
      }

      const $currentSelectedCard = $(pageId).find('.card.active:has(> label)');
      $currentSelectedCard.removeClass('active');

      const $newlySelectedCard = $(e.currentTarget).closest('.card');
      $newlySelectedCard.addClass('active');
    }

    private toggleInvoicesPreview(e: { currentTarget: HTMLElement }): void {
      const recurringTerm = $(e.currentTarget).data('recurring-term');
      if (!recurringTerm) return;

      $(
        `#invoices-preview-basic-stripe_card #invoices-preview-table:not('.${recurringTerm}')`,
      ).hide();
      $(
        `#invoices-preview-basic-stripe_card #invoices-preview-table.${recurringTerm}`,
      ).show();
      $(
        `#invoices-preview-basic-stripe_konbini #invoices-preview-table:not('.${recurringTerm}')`,
      ).hide();
      $(
        `#invoices-preview-basic-stripe_konbini #invoices-preview-table.${recurringTerm}`,
      ).show();
    }

    private onCreateSuccess(data: any): void {
      // 3DS認証が不要な場合はリダイレクトして処理を終了する。
      // コンビニ払いは 3DS 認証が不要なため、ここでリダイレクトして処理を終了する。
      if (!data.requires_3ds) {
        window.location.href = data.redirect_url;
        return;
      }

      this.stripe
        .handleNextAction({
          clientSecret: data.client_secret_for_3ds,
        })
        .then((result) => {
          if (result.error) {
            this.showAlert([result.error.message || '3DS認証に失敗しました']);
            $.rails.enableFormElements(this.ui.rawForm);
            this.initStripeElement();
          } else {
            window.location.href = data.redirect_url;
          }
        })
        .catch(() => {
          // handleNextAction は常に result object を返すので、ここはネットワークエラーになる見込み。
          // https://docs.stripe.com/js/payment_intents/handle_next_action
          this.showAlert([
            '処理に失敗しました。お手数ですが再度ご操作ください。',
          ]);
          $.rails.enableFormElements(this.ui.rawForm);
          this.initStripeElement();
        });
    }

    private onCreateFailure(xhr: JQuery.jqXHR<any>): void {
      if (xhr.responseJSON?.redirect) {
        window.location.href = xhr.responseJSON.redirect_url;
      } else {
        this.showAlert(xhr.responseJSON?.errors);
        $.rails.enableFormElements(this.ui.rawForm);
        if (this.getPaymentMethod() === 'stripe_card') {
          this.initStripeElement();
        }
      }
    }

    private hideAlert(): void {
      this.ui.alertRow.slideUp().find('ul').empty();
    }

    private showAlert(errors: string[]): void {
      let element = $('.wizard-step.active');

      if (element.attr('id') === 'choose-plan') {
        element = element.find(`#choose-plan-${this.plan}`);
      }

      const $ul = element.find('.alert-row ul');

      // When an unexpected error occurred, the server may not return proper message.
      // So we have to show a default message for that case.
      if (!errors) {
        errors = [$ul.data('default-error-message')];
      }

      for (const error of errors) {
        $ul.append(`<li>${error}</li>`);
      }
      $ul.closest('.alert-row').slideDown();
    }

    private submit(e: JQuery.Event): boolean {
      e.preventDefault();
      $.rails.disableFormElements(this.ui.rawForm);

      this.hideAlert();
      this.reNewForm();

      const onValidateSuccess = (): Promise<void> => {
        this.form
          ?.submit()
          .done(this.onCreateSuccess.bind(this))
          .fail(this.onCreateFailure.bind(this));
        return new Promise((resolve) => resolve());
      };

      this.form
        ?.validate()
        .then(onValidateSuccess)
        .catch(this.onFailure.bind(this));

      return false;
    }

    private getInvoicesPreview(): JQuery.jqXHR<any> {
      const params = {
        'order[course]': this.plan,
        'order[payment_method]': this.getPaymentMethod(),
        'order[coupon_code]': this.ui.couponInput.val(),
      };
      // getだとセッション切れの場合にリダイレクトの結果ログイン画面が返却されるためpostにしている
      return $.post(this.ui.rawForm.data('invoices-preview-path'), params);
    }

    private renderInvoicesPreview(data: any): void {
      $(`#invoices-preview-${this.plan}-${this.getPaymentMethod()}`).html(data);

      const couponResult = $(data)
        .find('.coupon-application-result')
        .data('result');

      switch (couponResult.status) {
        case 'success':
          this.showCouponSuccessState(couponResult);
          break;

        case 'failure':
          this.showCouponFailureState();
          break;

        case 'not_specified':
          this.showCouponInputState();
          break;
      }
    }

    // クーポン適用成功時のUI状態
    private showCouponSuccessState(couponResult: any): void {
      // クーポン入力フォームを非表示
      this.ui.couponInputForm.addClass('hidden');
      this.ui.couponInput.prop('disabled', true);
      this.ui.applyCouponButton.prop('disabled', true);

      // 適用したクーポン情報を表示
      this.ui.appliedCouponInfo.removeClass('hidden');
      this.ui.appliedCouponCode.text(couponResult.input_coupon_code);
      this.ui.appliedCouponName.text(couponResult.coupon_name);

      // エラーメッセージを非表示
      this.ui.couponErrorMessage.addClass('hidden');
    }

    // クーポン適用失敗時のUI状態
    private showCouponFailureState(): void {
      // クーポン入力フォームを表示
      this.ui.couponInputForm.removeClass('hidden');
      this.ui.couponInput.prop('disabled', false);
      this.ui.applyCouponButton.prop('disabled', false);

      // 適用したクーポン情報を非表示
      this.ui.appliedCouponInfo.addClass('hidden');
      this.ui.appliedCouponCode.text('');
      this.ui.appliedCouponName.text('');

      // エラーメッセージを表示
      this.ui.couponErrorMessage.removeClass('hidden');
      this.ui.couponErrorMessage.text('エラー：このコードは利用できません');
    }

    // クーポン入力初期状態 (not_specified のとき)
    private showCouponInputState(): void {
      // クーポン入力フォームを表示
      this.ui.couponInputForm.removeClass('hidden');
      this.ui.couponInput.prop('disabled', false);
      this.ui.applyCouponButton.prop('disabled', false);

      // 適用したクーポン情報を非表示
      this.ui.appliedCouponInfo.addClass('hidden');
      this.ui.appliedCouponCode.text('');
      this.ui.appliedCouponName.text('');

      // エラーメッセージを非表示
      this.ui.couponErrorMessage.addClass('hidden');
    }

    private onFailure(error: JQuery.jqXHR | string[]): void {
      const errorMessages = Array.isArray(error)
        ? error
        : error.responseJSON?.errors;
      this.showAlert(errorMessages);
      $.rails.enableFormElements(this.ui.rawForm);
    }

    private reNewForm(): void {
      if (this.getPaymentMethod() === 'stripe_card') {
        this.form = new CreditCardForm(
          this.ui.rawForm,
          this.confirmSetupIntent.bind(this),
          this.stripeElements!,
          this.ui.appliedCouponCode.text(),
        );
      } else if (this.getPaymentMethod() === 'stripe_konbini') {
        this.form = new KonbiniForm(
          this.ui.rawForm,
          this.stripeIdempotencyKey!,
        );
      } else {
        this.form = new BaseForm(this.ui.rawForm);
      }
    }

    private toggleRequiredClass(e: Event): void {
      if (!(e.currentTarget instanceof HTMLElement)) {
        return;
      }

      const $select = $(e.currentTarget).prev();
      const hasClass =
        !$select.hasClass('has-value') && $select.prop('required');
      $('.select2-dropdown').toggleClass('required', hasClass);
    }

    private toggleHasValue(e: Event): void {
      if (!(e.currentTarget instanceof HTMLElement)) {
        return;
      }
      const value = (e.target as HTMLInputElement).value;

      $(e.currentTarget).toggleClass('has-value', !!value);
    }
  }

  // activate
  if ($('#page_registration-v2-personal_orders_new').is(':visible')) {
    loadStripe(stripeConfig.publishableApiKey, { locale: 'ja' }).then(
      (stripe: Stripe) => {
        const view = new RegistrationPersonalOrderView(stripe);
        view.begin();
      },
    );
  }
});
